import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
// @ts-ignore
import Flowchart from '../flow-elements/flowchart/flowchart.vue';

@Component({
	components: {
		Flowchart,
	},
})
export default class FlowContainer extends Vue {
	@PropSync('nodes')
	public localNodes?: any[];

	@PropSync('links')
	public localLinks?: any[];

	@Prop()
	public disabled?: boolean;

	public data: any = {
		centerX: 0,
		centerY: 0,
		scale: 1,
	};
}
